import { Stack, Container, Spacer } from '@backyard-ui/core'

import { useUserResources } from 'shared/hooks'

import { useEntryStore } from '../../Entry.store'
import { RetailMediaBanner } from '../../ui/RetailMediaBanner'
import { SearchResultTabs } from '../../ui/SearchResultTabs'
import { TabProvider } from '../../contexts/TabContext'
import { useServerContext } from '../../routes/routes.context'
import { SCROLL_THRESHOLD } from './constants'
import { useScrollThreshold } from './hooks/useScrollThreshold'
import { GridContent, FloatingFilterButton } from './components'
import { Content as SearchProductList } from '../../ui/Content'

function EntryPage() {
  const { userResources } = useUserResources()
  const { isFiltersOpened, toggleFilters } = useEntryStore(state => state.ui)
  const isScrolled = useScrollThreshold(SCROLL_THRESHOLD)
  const { isServicesSearchbarEnabled = false } = useServerContext()
  const showRetailMedia = window.env.newTail.enabled

  if (!userResources?.region) {
    return null
  }

  const pageContent = isServicesSearchbarEnabled ? (
    <TabProvider>
      <SearchResultTabs />
    </TabProvider>
  ) : (
    <GridContent showRetailMedia={showRetailMedia}>
      <SearchProductList region={userResources.region} />
    </GridContent>
  )

  return (
    <Stack direction="column">
      <Container size={{ initial: '3xl', lg: '6xl' }} className="w-full">
        <Stack direction="column" className="mt-4">
          {showRetailMedia && <RetailMediaBanner />}
          {pageContent}
        </Stack>
        <Spacer />
      </Container>

      <FloatingFilterButton
        isVisible={!isFiltersOpened}
        isScrolled={isScrolled}
        onToggleFilters={toggleFilters}
      />
    </Stack>
  )
}

export default EntryPage
